module.exports = __webpack_public_path__ + "static/img/Samsara Agung-full.a22176d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile/full/Samsara Agung-full.png
// module id = m6b2
// module chunks = 1